//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
  },
  name: 'login',
  data() {
    return {
      loginWords: {
        label: ['用户名', '密码'],
        placeHolder: ['请输入用户名', '请输入密码']
      }
    }
  },
  methods: {
    ...mapActions([
      'getLogin',
      'AgetCrf',
      'AgetCollection'
    ])
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'crfcode',
      'collection',
      'baseURL'
    ])
  },
  created() {
  },
  mounted() {
  }
};
